import { FLAG_CONTENT_HUB_ENABLE_SPEAKER_EDIT } from '@app/feature-flags/flags';
import { useFlag } from '@app/feature-flags/use-flag';
import { useFlags } from '@app/hooks/use-flags';
import {
  FLAG_ENABLE_STANDALONE_STUDIO,
  FLAG_POST_EVENT_ORG_RECORDINGS_UPLOAD,
} from '@app/utilities/flags';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectRecording, selectRecordingTranscript } from '../../../selector';
import { EventDetails as EventDetailsCard } from './event-details';
import { HeaderSection } from './header-section';
import { ParentVideo as ParentVideoCard } from './parent-video';
import { RelatedVideos as RelatedVideosCard } from './related-videos';
import { SpeakerList } from './speaker-list';

export const Details = () => {
  const flags = useFlags();
  const recording = useSelector(selectRecording);
  const { data: transcriptData } = useSelector(selectRecordingTranscript);
  const transcriptSegments = transcriptData?.transcript?.segments;

  const isSpeakerEditEnabled = flags?.[FLAG_CONTENT_HUB_ENABLE_SPEAKER_EDIT];
  const isOrgLevelRecordingEnabled =
    flags?.[FLAG_POST_EVENT_ORG_RECORDINGS_UPLOAD];
  const isStandaloneStudioEnabled = useFlag(FLAG_ENABLE_STANDALONE_STUDIO);

  const isStandaloneStudioRecording =
    isStandaloneStudioEnabled &&
    recording?.category === 'main' &&
    recording?.event_id === null;

  const isOrgLevelRecording =
    isOrgLevelRecordingEnabled &&
    recording?.category === 'upload' &&
    recording?.event_id === null;

  return (
    <div className="flex flex-col gap-3 px-2">
      <HeaderSection />
      {!isStandaloneStudioRecording && !isOrgLevelRecording && (
        <EventDetailsCard />
      )}
      {isSpeakerEditEnabled &&
        transcriptSegments &&
        transcriptSegments.length > 0 && <SpeakerList />}
      {!isStandaloneStudioRecording && (
        <>
          <ParentVideoCard />
          <RelatedVideosCard />
        </>
      )}
    </div>
  );
};
